var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ajouter-un-consultant",
    transform: "translate(-1003.000000, -163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(314.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross_close",
    transform: "translate(689.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L25,0 C30.5228475,-1.01453063e-15 35,4.4771525 35,10 L35,25 C35,30.5228475 30.5228475,35 25,35 L10,35 C4.4771525,35 6.76353751e-16,30.5228475 0,25 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z",
    id: "Rectangle-Copy-4",
    fillOpacity: 0.1,
    fill: "#5AADB2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 17.000000) rotate(-45.000000) translate(-18.000000, -17.000000) translate(10.416667, 9.416667)",
    stroke: "#5AADB2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.58333333,
    y1: 2.11809539e-13,
    x2: 7.58333333,
    y2: 15.1666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.27606745e-13,
    y1: 7.58333333,
    x2: 15.1666667,
    y2: 7.58333333,
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossClose);
export default __webpack_public_path__ + "static/media/cross_close.af99e6371370cdb07cb0de4991e420ca.svg";
export { ForwardRef as ReactComponent };